import { ActionOverRecordTypes, triggerAction, FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX, IActionsSchema, ZendraLocalizationServices } from '@zendra/shared';
import { HarvestBlockService, PlanTypeService, PropertyService } from 'cbd-proxies';

FieldBuilder.setNamespace('Operational');

export const ROADPLAN_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('planVersion', 'Entity.RoadPlan.PlanVersion')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .date('startDate', 'Entity.RoadPlan.StartDate')
    .required()
    .build(),
  FieldBuilder
    .number('periodKilometers', 'Entity.RoadPlan.PeriodKilometers')
    .required()
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'planTypeId',
    'Entity.PlanType',
    PlanTypeService
  )
    .required()
    .display('name')
    .displayFromNested('planTypeName')
    .sortBy('planTypeName')
    .keyField('id')
    .readOnly()
    .showReadOnlyInForm()
    .build(),
  FieldBuilder.foreignKey('propertyId', 'Entity.Property', PropertyService)
    .display('name')
    .displayFromNested('propertyName')
    .sortBy('propertyName')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'harvestBlockId',
    'Entity.HarvestBlock',
    HarvestBlockService
  )
    .required()
    .display('name')
    .displayFromNested('harvestBlockName')
    .sortBy('harvestBlockName')
    .keyField('id')
    .build(),
  FieldBuilder
    .number('versionId', 'Entity.RoadPlan.VersionId')
    .required()
    .hideByDefault()
    .build(),
];

export const ACTION_IDS = {
  importExcelModal: 0,
  downloadExcelTemplateTrigger: 1,
} as const;

export const ROAD_PLAN_ACTION_IDS = ACTION_IDS;

export const ROADPLAN_ACTIONS: IActionsSchema = {
  overTable: [
    triggerAction(
      ACTION_IDS.importExcelModal,
      'Action:ExcelImport',
      ActionOverRecordTypes.OverTable,
      ZendraLocalizationServices.LanguageService,
    ),
    triggerAction(
      ACTION_IDS.downloadExcelTemplateTrigger,
      'Actions:ExcelTemplateDownload',
      ActionOverRecordTypes.OverTable,
      ZendraLocalizationServices.LanguageService,
    )
  ],
};

export const ROAD_PLAN_ACTIONS_CONFIG = ROADPLAN_ACTIONS;

export const ROADPLAN_CONFIG = {
  entityName: 'RoadPlan',
  localizationKey: 'Operational::Entity.RoadPlan',
  fields: ROADPLAN_FIELDS,
  permission: 'PlanningOperation.RoadPlans',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.PlanningOperational + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Road + MENU_NAME_SUFFIX,
  actions: ROAD_PLAN_ACTION_IDS,
  actionIds: ACTION_IDS,
};
